// Copyright (c) 2017 Deere & Company

export const hasCreditMemoAction = allowedActions =>
    allowedActions.some(action => action.id === 'CRDMEM');



// WEBPACK FOOTER //
// ./src/shared/services/allowed-actions-services.js